(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["animated-testimonials-group"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('animated-testimonials-group')) {
    customElements.define(
      'animated-testimonials-group',
      class extends HTMLElement {
        connectedCallback() {
          this.animations = [];
          this.index = 0;
          this.paused = false;
          this.inView = false;
          this.abort = new AbortController();
          const options = { signal: this.abort.signal };
          this.preference = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.track = this.querySelector('.atg-track');
          this.slides = Array.from(this.track.querySelectorAll('[data-atg-slide]'));
          this.media = Array.from(this.querySelectorAll('[data-atg-media]'));
          this.controls = this.querySelector('.atg-controls');
          this.isCarousel = this.dataset.layout === 'carousel' && this.slides.length > 0;
          this.onPreferenceChange = () => {
            this.cancelAnimations();
            this.schedule();
          };
          this.preference.addEventListener('change', this.onPreferenceChange);
          document.addEventListener('visibilitychange', () => this.schedule(), options);
          document.addEventListener(
            'shopify:block:select',
            (event) => {
              const index = this.slides.findIndex((slide) => slide === event.target || slide.contains(event.target));
              if (index < 0) return;
              this.paused = true;
              if (this.isCarousel) this.show(index, false);
              this.cancelAnimations();
              this.schedule();
            },
            options,
          );
          if (this.isCarousel) {
            this.setAttribute('data-ready', '');
            this.setAttribute('role', 'region');
            this.setAttribute('aria-roledescription', 'carousel');
            this.setAttribute('aria-label', this.controls.querySelector('[data-atg-status]').dataset.regionLabel);
            this.controls.hidden = this.slides.length < 2;
            this.media.forEach((media) => {
              media.setAttribute('aria-hidden', 'true');
              media.inert = true;
            });
            this.querySelector('.atg-carousel-media').removeAttribute('aria-hidden');
            this.querySelectorAll('.atg-quote').forEach((quote) => this.prepareWords(quote));
            this.show(0, false);
            this.addEventListener(
              'click',
              (event) => {
                const button = event.target.closest('button');
                if (!button || !this.controls.contains(button)) return;
                if (button.hasAttribute('data-atg-pause')) this.paused = !this.paused;
                else if (button.hasAttribute('data-atg-next')) this.show(this.index + 1);
                else if (button.hasAttribute('data-atg-prev')) this.show(this.index - 1);
                this.schedule();
              },
              options,
            );
            this.addEventListener(
              'keydown',
              (event) => {
                if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
                if (!this.controls.contains(event.target)) return;
                event.preventDefault();
                this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
                this.schedule();
              },
              options,
            );
            ['pointerenter', 'pointerleave', 'focusin', 'focusout'].forEach((type) =>
              this.addEventListener(type, () => this.schedule(), options),
            );
          }
          if ('IntersectionObserver' in window) {
            this.observer = new IntersectionObserver(
              (entries) => {
                this.inView = entries.some((entry) => entry.isIntersecting);
                if (this.isCarousel) this.schedule();
                else if (this.inView && !this.entered) {
                  this.entered = true;
                  this.observer.disconnect();
                  if (this.motionEnabled() && this.dataset.scrollReveal !== 'false')
                    Array.from(this.track.children)
                      .filter((card) => !card.classList.contains('atg-app'))
                      .forEach((card, index) =>
                        this.animate(
                          card,
                          [
                            { opacity: 0.35, transform: 'translateY(18px)', filter: 'blur(3px)' },
                            { opacity: 1, transform: 'translateY(0)', filter: 'blur(0)' },
                          ],
                          { delay: Math.min(index * 60, 300) },
                        ),
                      );
                }
              },
              { threshold: 0 },
            );
            this.observer.observe(this);
          }
        }
        motionEnabled() {
          return (
            this.dataset.animate === 'true' &&
            this.dataset.globalMotion !== 'none' &&
            !this.preference.matches &&
            Boolean(Element.prototype.animate)
          );
        }
        animate(element, frames, options = {}) {
          const animation = element.animate(frames, {
            duration: 500,
            easing: 'cubic-bezier(0.16, 1, 0.3, 1)',
            fill: 'backwards',
            ...options,
          });
          this.animations.push(animation);
        }
        cancelAnimations() {
          this.animations.forEach((animation) => animation.cancel());
          this.animations = [];
        }
        prepareWords(quote) {
          // Preserve rich text markup and whitespace instead of replacing innerHTML.
          const walker = document.createTreeWalker(quote, NodeFilter.SHOW_TEXT);
          const nodes = [];
          while (walker.nextNode()) nodes.push(walker.currentNode);
          nodes.forEach((node) => {
            const fragment = document.createDocumentFragment();
            node.textContent
              .split(/(\s+)/)
              .filter(Boolean)
              .forEach((word) => {
                if (/^\s+$/.test(word)) fragment.append(document.createTextNode(word));
                else {
                  const span = document.createElement('span');
                  span.className = 'atg-word';
                  span.textContent = word;
                  fragment.append(span);
                }
              });
            node.replaceWith(fragment);
          });
        }
        show(index, animate = true, announce = true) {
          this.cancelAnimations();
          this.index = (index + this.slides.length) % this.slides.length;
          const active = this.slides[this.index];
          this.slides.forEach((slide, i) => {
            slide.hidden = i !== this.index;
            slide.inert = i !== this.index;
            slide.setAttribute('aria-hidden', String(i !== this.index));
          });
          this.media.forEach((media) => {
            const selected = media.dataset.atgMedia === active.dataset.atgSlide;
            const previousTransform = getComputedStyle(media).transform;
            media.classList.toggle('is-active', selected);
            media.inert = !selected;
            media.setAttribute('aria-hidden', String(!selected));
            const link = media.querySelector('a');
            if (link) link.tabIndex = selected ? 0 : -1;
            if (selected && animate && this.motionEnabled())
              this.animate(media, [
                { transform: previousTransform, opacity: 0.65 },
                { transform: 'rotate(0deg) scale(1)', opacity: 1 },
              ]);
          });
          if (animate && this.motionEnabled()) {
            this.animate(
              active,
              [
                { opacity: 0, transform: 'translateY(8px)' },
                { opacity: 1, transform: 'translateY(0)' },
              ],
              { duration: 300 },
            );
            active.querySelectorAll('.atg-word').forEach((word, i) =>
              this.animate(
                word,
                [
                  { opacity: 0, filter: 'blur(4px)', transform: 'translateY(4px)' },
                  { opacity: 1, filter: 'blur(0)', transform: 'translateY(0)' },
                ],
                { duration: 300, delay: Math.min(i * 20, 450) },
              ),
            );
          }
          const status = this.controls.querySelector('[data-atg-status]');
          // Automatic changes must not repeatedly interrupt screen readers.
          status.setAttribute('aria-live', announce ? 'polite' : 'off');
          status.textContent = status.dataset.label
            .replace('[current]', this.index + 1)
            .replace('[total]', this.slides.length);
        }
        schedule() {
          clearTimeout(this.timer);
          const button = this.querySelector('[data-atg-pause]');
          if (button) button.textContent = this.paused ? button.dataset.playLabel : button.dataset.pauseLabel;
          if (
            !this.isCarousel ||
            this.slides.length < 2 ||
            this.dataset.autoplay !== 'true' ||
            this.paused ||
            !this.inView ||
            this.preference.matches ||
            document.hidden ||
            this.matches(':hover') ||
            this.contains(document.activeElement)
          )
            return;
          this.timer = setTimeout(() => {
            this.show(this.index + 1, true, false);
            this.schedule();
          }, Math.max(2000, Number(this.dataset.delay) || 5000));
        }
        disconnectedCallback() {
          clearTimeout(this.timer);
          this.observer?.disconnect();
          this.cancelAnimations();
          this.abort.abort();
          this.preference.removeEventListener('change', this.onPreferenceChange);
          this.removeAttribute('data-ready');
          if (this.controls) this.controls.hidden = true;
          this.slides.forEach((slide) => {
            slide.hidden = false;
            slide.inert = false;
            slide.removeAttribute('aria-hidden');
          });
          this.querySelectorAll('.atg-word').forEach((word) =>
            word.replaceWith(document.createTextNode(word.textContent)),
          );
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed-products"] && !Shopify.designMode) return;
  try {
    
  class RecentlyViewedProducts extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      try {
        const storage = this.dataset.memory === 'browser' ? window.localStorage : window.sessionStorage;
        const currentNode = this.querySelector('[data-recently-viewed-current]');
        const current = currentNode ? JSON.parse(currentNode.textContent) : null;
        const maximumAge = Number(this.dataset.maxAge || 30) * 86400000;
        const saved = JSON.parse(storage.getItem(this.dataset.storageKey) || '[]');
        const valid = Array.isArray(saved)
          ? saved.filter((item) => item?.handle && Date.now() - Number(item.seenAt || 0) < maximumAge)
          : [];
        const visible = valid
          .filter((item) => item.handle !== current?.handle)
          .slice(0, Number(this.dataset.limit || 4));

        if (visible.length) this.renderProducts(visible);
        if (current?.handle) {
          storage.setItem(
            this.dataset.storageKey,
            JSON.stringify(
              [{ ...current, seenAt: Date.now() }, ...valid.filter((item) => item.handle !== current.handle)].slice(
                0,
                12,
              ),
            ),
          );
        }
      } catch (error) {
        if (this.dataset.designMode !== 'true') this.hidden = true;
      }
    }

    disconnectedCallback() {
      this.initialized = false;
    }

    renderProducts(products) {
      const list = this.querySelector('[data-recently-viewed-list]');
      const template = this.querySelector('[data-recently-viewed-template]');
      if (!list || !template) return;
      const fragment = document.createDocumentFragment();
      products.forEach((product) => {
        const item = template.content.cloneNode(true);
        item.querySelectorAll('[data-recent-link]').forEach((link) => {
          link.href = product.url;
        });
        const mediaLink = item.querySelector('.product-card__media');
        if (mediaLink) mediaLink.setAttribute('aria-label', product.title);
        const title = item.querySelector('[data-recent-title]');
        if (title) title.textContent = product.title;
        const price = item.querySelector('[data-recent-price]');
        if (price) price.textContent = product.price;
        const vendor = item.querySelector('[data-recent-vendor]');
        if (vendor && product.vendor) {
          vendor.textContent = product.vendor;
          vendor.hidden = false;
        }
        const soldOut = item.querySelector('[data-recent-sold-out]');
        if (soldOut) soldOut.hidden = product.available !== false;
        const image = item.querySelector('[data-recent-image]');
        if (image && product.image) {
          image.src = product.image;
          image.alt = product.imageAlt || product.title;
          image.width = Number(product.imageWidth || 900);
          image.height = Number(product.imageHeight || 1125);
          image.hidden = false;
          item.querySelector('[data-recent-placeholder]')?.setAttribute('hidden', '');
        }
        fragment.appendChild(item);
      });
      list.replaceChildren(fragment);
      this.querySelector('[data-recently-viewed-empty]')?.setAttribute('hidden', '');
      this.hidden = false;
    }
  }

  if (!customElements.get('recently-viewed-products'))
    customElements.define('recently-viewed-products', RecentlyViewedProducts);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-focus"] && !Shopify.designMode) return;
  try {
    
  class TestimonialSlideshow extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.slides = [...this.querySelectorAll('[data-rail-item]')];
      if (!this.slides.length) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.currentIndex = 0;
      this.hovered = false;
      this.focused = false;
      this.visible = false;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.motion.matches || Boolean(window.Shopify?.designMode);
      this.delay = Math.max(5000, Number(this.dataset.delay) || 10000);
      this.track = this.querySelector('[data-rail-track]');
      this.progress = this.querySelector('[data-rail-progress]');
      this.pauseButton = this.querySelector('[data-testimonial-pause]');
      this.querySelector('[data-rail-previous]')?.addEventListener('click', () => this.goTo(this.currentIndex - 1, true), options);
      this.querySelector('[data-rail-next]')?.addEventListener('click', () => this.goTo(this.currentIndex + 1, true), options);
      this.pauseButton?.addEventListener('click', () => {
        this.paused = !this.paused;
        this.update();
        this.startTimer();
      }, options);
      this.addEventListener('pointerenter', () => {
        this.hovered = true;
        this.stopTimer();
      }, options);
      this.addEventListener('pointerleave', () => {
        this.hovered = false;
        this.startTimer();
      }, options);
      this.addEventListener('focusin', () => {
        this.focused = true;
        this.stopTimer();
      }, options);
      this.addEventListener('focusout', (event) => {
        this.focused = this.contains(event.relatedTarget);
        this.startTimer();
      }, options);
      this.addEventListener('keydown', (event) => {
        // Leave arrow keys available inside app blocks and editable content.
        if (event.target !== this && !event.target.closest('[data-rail-previous], [data-rail-next], [data-testimonial-pause]')) return;
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const direction = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
        this.goTo(this.currentIndex + (event.key === 'ArrowRight' ? direction : -direction), true);
      }, options);
      document.addEventListener('visibilitychange', () => this.startTimer(), options);
      document.addEventListener('shopify:block:select', (event) => {
        const slide = event.target.closest('[data-rail-item]');
        if (!slide || !this.contains(slide)) return;
        this.paused = true;
        this.goTo(this.slides.indexOf(slide), true);
      }, options);
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) this.paused = true;
        this.update();
        this.startTimer();
      }, options);
      this.dataset.multiple = String(this.slides.length > 1);
      this.update();
      this.dataset.ready = 'true';
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(([entry]) => {
          this.visible = entry.isIntersecting;
          this.startTimer();
        });
        this.observer.observe(this);
      } else {
        this.visible = true;
        this.startTimer();
      }
    }

    goTo(index, userInitiated = false) {
      this.style.setProperty('--testimonial-direction', index < this.currentIndex ? -1 : 1);
      this.currentIndex = (index + this.slides.length) % this.slides.length;
      this.update(userInitiated);
      this.startTimer();
    }

    update(userInitiated = false) {
      // Automatic rotation stays quiet; navigation announces the selected quote.
      this.track?.setAttribute('aria-live', userInitiated || this.paused ? 'polite' : 'off');
      this.slides.forEach((slide, index) => {
        const active = index === this.currentIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
      });
      const progress = (this.currentIndex + 1) / this.slides.length;
      this.style.setProperty('--rail-progress', progress);
      this.progress?.setAttribute('aria-valuenow', String(Math.round(progress * 100)));
      if (this.pauseButton) {
        const label = this.paused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel;
        this.pauseButton.textContent = label;
        this.pauseButton.setAttribute('aria-label', label);
      }
    }

    startTimer() {
      this.stopTimer();
      if (this.paused || this.hovered || this.focused || !this.visible || document.hidden || this.slides.length < 2) return;
      this.timer = window.setTimeout(() => this.goTo(this.currentIndex + 1), this.delay);
    }

    stopTimer() {
      window.clearTimeout(this.timer);
    }

    disconnectedCallback() {
      this.stopTimer();
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
      // Restore all content if detached without a subsequent upgrade.
      delete this.dataset.ready;
      this.slides?.forEach((slide) => {
        slide.inert = false;
        slide.removeAttribute('aria-hidden');
      });
    }
  }

  if (!customElements.get('testimonial-slideshow')) {
    customElements.define('testimonial-slideshow', TestimonialSlideshow);
  }

  } catch(e) { console.error(e); }
})();
})();
